import { Component, OnInit, ViewChild } from '@angular/core';
import { CompanyApiService } from 'src/app/services/api/companies.api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserApiService } from 'src/app/services/api/user.api.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Company } from 'src/app/classes/Company.class';
import { User } from 'src/app/classes/User.class';
import { Role } from 'src/app/classes/Role.class';
import { getRoles } from 'src/assets/data/roles';
import { arrSuperUsers } from 'src/app/services/utility-functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'company-summary-screen',
  templateUrl: './company-summary.screen.html',
  styleUrls: ['./company-summary.screen.scss'],
})
export class CompanySummaryScreenComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<User>;
  displayedColumns: string[];

  company: Company;
  companyUsers: User[];
  roles: Role[];
  superUserArr: User[];
  showModal = false;

  constructor(
    private companyApiService: CompanyApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userApiService: UserApiService,
    private _location: Location,
    private translate: TranslateService,
  ) {}

  async ngOnInit() {
    await this.activatedRoute.params.subscribe(async params => {
      const companyId = params.companyId;
      this.company = await this.companyApiService.getCompany(companyId);
      this.companyUsers = await this.userApiService.getUsersForCompany(companyId);
      this.roles = getRoles(true, this.translate.getDefaultLang());
      this.displayedColumns = ['firstName', 'lastName', 'role', 'details'];
      this.dataSource = new MatTableDataSource<User>(this.companyUsers);
      this.dataSource.paginator = this.paginator;
      if (await this.userApiService.getIfMowaAdmin()) {
        this.superUserArr = this.checkForSuperUser(this.companyUsers);
      }
    });
  }

  editCompany() {
    this.router.navigateByUrl(`companies/${this.company.id}/edit`);
  }

  viewUser(userId: number) {
    this.router.navigateByUrl(`users/${userId}`);
  }

  goBack() {
    this._location.back();
  }

  /**
   * chek if user has more than one super user
   */
  checkForSuperUser(users: User[]) {
    const arr: User[] = arrSuperUsers(users);
    if (arr.length > 1) this.showModal = true;
    return arr;
  }

  async changeRoles(user) {
    this.superUserArr.forEach(async el => {
      if (user !== el) {
        const response = await this.userApiService.updateUserRole(el.id, 'admin');
        if (response) location.reload();
      }
    });

    this.showModal = false;
  }
}
